import { default as app_45errorvP3UTS7RtEMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/app-error.vue?macro=true";
import { default as _91id_93gT6m9ddJTsMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsCast/[id].vue?macro=true";
import { default as _91id_936WxVm6QuJOMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsPrograms/[id].vue?macro=true";
import { default as _91id_93PpqitYaAb4Meta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodMovies/[id].vue?macro=true";
import { default as _91id_939Z2tp5jUo3Meta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodSeries/[id].vue?macro=true";
import { default as indexlpBQu03x1lMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/guide/index.vue?macro=true";
import { default as indexioFEwb9uNFMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/help/index.vue?macro=true";
import { default as indexzUORmAXvj6Meta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/index.vue?macro=true";
import { default as show_45allgv7qHs9PIDMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/show-all.vue?macro=true";
import { default as indexQUqUriYV3DMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/index.vue?macro=true";
import { default as forgotPOQuS9ccwSMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/forgot.vue?macro=true";
import { default as indexlvU0XREkjQMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/index.vue?macro=true";
import { default as sign_45inbvmPHQezd4Meta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/sign-in.vue?macro=true";
import { default as all_45on_45demandpc4yk7IOXcMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-on-demand.vue?macro=true";
import { default as all_45programsyzqSJjme5xMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-programs.vue?macro=true";
import { default as indexcCEmGrqNGxMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/index.vue?macro=true";
import { default as show_45all_45fav_45channelsVoMyff3cxEMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/show-all-fav-channels.vue?macro=true";
import { default as index5aOZWFWKYdMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/player/index.vue?macro=true";
import { default as playerEdXXUrwNO2Meta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/player.vue?macro=true";
import { default as indexHBaVyb21CCMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/index.vue?macro=true";
import { default as show_45allO8CYpCzR08Meta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/show-all.vue?macro=true";
import { default as about_45usqzm3kXyKWxMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/about-us.vue?macro=true";
import { default as indexAKTmen1iCEMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/account/index.vue?macro=true";
import { default as clear_45cacheWzq4EYsZXNMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/clear-cache.vue?macro=true";
import { default as dev_45modenZXJkQvQN4Meta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/dev-mode.vue?macro=true";
import { default as favoritesg30PuuJm86Meta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/favorites.vue?macro=true";
import { default as index84gwUn325bMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/language/index.vue?macro=true";
import { default as indexgWik67g8lcMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/parent-control/index.vue?macro=true";
import { default as indexwtgpN54HjhMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/player/index.vue?macro=true";
import { default as privacy_45policytT1qlCSlIwMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/privacy-policy.vue?macro=true";
import { default as servicevod56o7oaJMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/service.vue?macro=true";
import { default as software_45licenseKZ1eaMQpptMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/software-license.vue?macro=true";
import { default as subscription3YGAgEssm2Meta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/subscription.vue?macro=true";
import { default as settingsMlSBr1ZG5rMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings.vue?macro=true";
import { default as loaderqnoaDuuH6tMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/loader.vue?macro=true";
import { default as logomA1ELZJIjzMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/logo.vue?macro=true";
import { default as maxiDo8CNQC2CiMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/maxi.vue?macro=true";
import { default as indexD0Q1y6hpNLMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/trailer/index.vue?macro=true";
import { default as _91id_93qVIXgfJagoMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/detail-genre/[id].vue?macro=true";
import { default as _91id_93qyxyLBuD3mMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres-premium/[id].vue?macro=true";
import { default as _91id_93ORU8lFuXVaMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres/[id].vue?macro=true";
import { default as indexPFnxRBKXxtMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/index.vue?macro=true";
import { default as show_45all_45channels1lvxq5ydyCMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-channels.vue?macro=true";
import { default as show_45all_45moviesmkVYjfTI5VMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-movies.vue?macro=true";
import { default as show_45all_45subitemsfeM7hrQ0H2Meta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-subitems.vue?macro=true";
import { default as show_45all5ibzMUDOzYMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all.vue?macro=true";
export default [
  {
    name: "app-error",
    path: "/app-error",
    meta: app_45errorvP3UTS7RtEMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/app-error.vue").then(m => m.default || m)
  },
  {
    name: "detailsCast-id",
    path: "/detailsCast/:id()",
    meta: _91id_93gT6m9ddJTsMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsCast/[id].vue").then(m => m.default || m)
  },
  {
    name: "detailsPrograms-id",
    path: "/detailsPrograms/:id()",
    meta: _91id_936WxVm6QuJOMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsPrograms/[id].vue").then(m => m.default || m)
  },
  {
    name: "detailsVodMovies-id",
    path: "/detailsVodMovies/:id()",
    meta: _91id_93PpqitYaAb4Meta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodMovies/[id].vue").then(m => m.default || m)
  },
  {
    name: "detailsVodSeries-id",
    path: "/detailsVodSeries/:id()",
    meta: _91id_939Z2tp5jUo3Meta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodSeries/[id].vue").then(m => m.default || m)
  },
  {
    name: "guide",
    path: "/guide",
    meta: indexlpBQu03x1lMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/guide/index.vue").then(m => m.default || m)
  },
  {
    name: "help",
    path: "/help",
    meta: indexioFEwb9uNFMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: "home",
    path: "/home",
    meta: indexzUORmAXvj6Meta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/index.vue").then(m => m.default || m)
  },
  {
    name: "home-show-all",
    path: "/home/show-all",
    meta: show_45allgv7qHs9PIDMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/show-all.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexQUqUriYV3DMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login-forgot",
    path: "/login/forgot",
    meta: forgotPOQuS9ccwSMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/forgot.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: indexlvU0XREkjQMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: "login-sign-in",
    path: "/login/sign-in",
    meta: sign_45inbvmPHQezd4Meta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/sign-in.vue").then(m => m.default || m)
  },
  {
    name: "mytv-all-on-demand",
    path: "/mytv/all-on-demand",
    meta: all_45on_45demandpc4yk7IOXcMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-on-demand.vue").then(m => m.default || m)
  },
  {
    name: "mytv-all-programs",
    path: "/mytv/all-programs",
    meta: all_45programsyzqSJjme5xMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-programs.vue").then(m => m.default || m)
  },
  {
    name: "mytv",
    path: "/mytv",
    meta: indexcCEmGrqNGxMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/index.vue").then(m => m.default || m)
  },
  {
    name: "mytv-show-all-fav-channels",
    path: "/mytv/show-all-fav-channels",
    meta: show_45all_45fav_45channelsVoMyff3cxEMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/show-all-fav-channels.vue").then(m => m.default || m)
  },
  {
    name: playerEdXXUrwNO2Meta?.name,
    path: "/player",
    meta: playerEdXXUrwNO2Meta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/player.vue").then(m => m.default || m),
    children: [
  {
    name: "player",
    path: "",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/player/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "search",
    path: "/search",
    meta: indexHBaVyb21CCMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: "search-show-all",
    path: "/search/show-all",
    meta: show_45allO8CYpCzR08Meta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/show-all.vue").then(m => m.default || m)
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings.vue").then(m => m.default || m),
    children: [
  {
    name: "settings-about-us",
    path: "about-us",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/about-us.vue").then(m => m.default || m)
  },
  {
    name: "settings-account",
    path: "account",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/account/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-clear-cache",
    path: "clear-cache",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/clear-cache.vue").then(m => m.default || m)
  },
  {
    name: "settings-dev-mode",
    path: "dev-mode",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/dev-mode.vue").then(m => m.default || m)
  },
  {
    name: "settings-favorites",
    path: "favorites",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/favorites.vue").then(m => m.default || m)
  },
  {
    name: "settings-language",
    path: "language",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/language/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-parent-control",
    path: "parent-control",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/parent-control/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-player",
    path: "player",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/player/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-privacy-policy",
    path: "privacy-policy",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "settings-service",
    path: "service",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/service.vue").then(m => m.default || m)
  },
  {
    name: "settings-software-license",
    path: "software-license",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/software-license.vue").then(m => m.default || m)
  },
  {
    name: "settings-subscription",
    path: "subscription",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/subscription.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "splash-loader",
    path: "/splash/loader",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/loader.vue").then(m => m.default || m)
  },
  {
    name: "splash-logo",
    path: "/splash/logo",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/logo.vue").then(m => m.default || m)
  },
  {
    name: "splash-maxi",
    path: "/splash/maxi",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/maxi.vue").then(m => m.default || m)
  },
  {
    name: "trailer",
    path: "/trailer",
    meta: indexD0Q1y6hpNLMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/trailer/index.vue").then(m => m.default || m)
  },
  {
    name: "vod-detail-genre-id",
    path: "/vod/detail-genre/:id()",
    meta: _91id_93qVIXgfJagoMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/detail-genre/[id].vue").then(m => m.default || m)
  },
  {
    name: "vod-genres-premium-id",
    path: "/vod/genres-premium/:id()",
    meta: _91id_93qyxyLBuD3mMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres-premium/[id].vue").then(m => m.default || m)
  },
  {
    name: "vod-genres-id",
    path: "/vod/genres/:id()",
    meta: _91id_93ORU8lFuXVaMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres/[id].vue").then(m => m.default || m)
  },
  {
    name: "vod",
    path: "/vod",
    meta: indexPFnxRBKXxtMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/index.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all-channels",
    path: "/vod/show-all-channels",
    meta: show_45all_45channels1lvxq5ydyCMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-channels.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all-movies",
    path: "/vod/show-all-movies",
    meta: show_45all_45moviesmkVYjfTI5VMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-movies.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all-subitems",
    path: "/vod/show-all-subitems",
    meta: show_45all_45subitemsfeM7hrQ0H2Meta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-subitems.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all",
    path: "/vod/show-all",
    meta: show_45all5ibzMUDOzYMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all.vue").then(m => m.default || m)
  }
]